export interface ProfileSignalRQuery {
  Barges?: string[];
  SystemIds?: string[];
  DeviceTickets?: { [key: string]: number[] | null };
  DeviceId?: string;
  TimeRange?: {
    Start: {
      date: string;
      offset: number;
      ticks: number;
    };
    End: {
      date: string;
      offset: number;
      ticks: number;
    };
  };
  Fields?: TProfileFields | null;
  AggregateWindowInMinutes?: number;
}

export enum ProfileFields {
  Density = 'Density',
  DriveGain = 'Drive gain',
  MassFlowRate = 'Mass flow rate',
  MassTotal = 'Mass total',
  Temperature = 'Temperature',
  VolumeFlowRate = 'Volume flow rate',
  VolumeTotal = 'Volume total',
  Pressure = 'External pressure input value',
}

export const ProfileFieldsArray = [
  ProfileFields.Density,
  ProfileFields.DriveGain,
  ProfileFields.MassFlowRate,
  ProfileFields.MassTotal,
  ProfileFields.Temperature,
  ProfileFields.VolumeFlowRate,
  ProfileFields.VolumeTotal,
  ProfileFields.Pressure,
] as const;

export type TProfileFields = typeof ProfileFieldsArray;

export interface IProfileData {
  timestamp: {
    date: string;
    offset: number;
    ticks: number;
  };
  data: IStreamDataPoint;
  isBunkering: boolean;
  deviceId: string;
}

export enum ProfileSignalRQueryOperation {
  SubscribeActiveSessionProfileDataSimplified = 'SubscribeActiveSessionProfileDataSimplified',
  SubscribeProfileData = 'SubscribeProfileData',
  SubscribeProfileDataSimplified = 'SubscribeProfileDataSimplified',
  SubscribeProfileSummary = 'SubscribeProfileSummary',
  SubscribeDeliverySummaryData = 'SubscribeDeliverySummaryData',
  SubscribeMfmAlertsData = 'SubscribeMfmAlertsData',
  GetFilterOptions = 'GetFilterOptions',
  SubscribeTransmissionDetails = 'SubscribeTransmissionDetails',
  SubmitSummary = 'SubmitSummary',
  SubscribeMfmDeviceBunkeringStatus = 'SubscribeMfmDeviceBunkeringStatus',
}

export enum BunkerFlowDirection {
  Undefined = 0,
  Inflow = 2,
  Outflow = 1,
}

export interface IStreamDataPoint {
  massFlowRate: number;
  volumeFlowRate: number;
  massTotal: number;
  volumeTotal: number;
  density: number;
  temperature: number;
  pressure: number;
  driveGain: number;
  tubeDamping: number | null;
  flowDirection: BunkerFlowDirection;
}

export interface IProfileData {
  timestamp: {
    date: string;
    offset: number;
    ticks: number;
  };
  data: IStreamDataPoint;
  isBunkering: boolean;
  deviceId: string;
}

export enum StreamDataPointKeys {
  massFlowRate = 'massFlowRate',
  volumeFlowRate = 'volumeFlowRate',
  massTotal = 'massTotal',
  volumeTotal = 'volumeTotal',
  density = 'density',
  temperature = 'temperature',
  pressure = 'pressure',
  driveGain = 'driveGain',
  tubeDamping = 'tubeDamping',
}

export const CHART_COLORS = {
  [StreamDataPointKeys.volumeTotal]: '#1F77B4', // Deep Blue
  [StreamDataPointKeys.massTotal]: '#FF7F0E', // Vivid Orange
  [StreamDataPointKeys.driveGain]: '#2CA02C', // Strong Green
  [StreamDataPointKeys.density]: '#D62728', // Bold Red
  [StreamDataPointKeys.massFlowRate]: '#9467BD', // Rich Purple
  [StreamDataPointKeys.temperature]: '#E377C2', // Bright Pink
  [StreamDataPointKeys.volumeFlowRate]: '#8C564B', // Warm Brown
  [StreamDataPointKeys.pressure]: '#17BECF', // Cyan Blue
  [StreamDataPointKeys.tubeDamping]: '#7F7F7F', // Neutral Gray
} as const;
